import ProtectedRoute from "./ProtectedRoute";

export { ProtectedRoute };

export default ProtectedRoute;
